<template>
  <div class="flex-column" style="height: 100%">
    <div class="pt-12" style="height: 50%">
      <p
        class="text-center pt-12 text-h2 font-weight-regular"
        style="color: #4A73C2;"
      >
        OBRIGADO!
      </p>
      <v-img
        class="d-block mx-auto mt-16"
        max-width="300px"
        src="../assets/done_icon.png"
      ></v-img>
    </div>
  </div>
</template>
<script>
import { router } from "../router";

export default {
  name: "Finish",
  data: () => ({}),
  mounted() {
    setTimeout(() => {
      this.logout();
    }, 1500);
  },
  methods: {
    backToLogin() {
      router.push({ name: "Home" });
    },
    logout(event) {
      this.$store.dispatch("logout", {completed_test: true});
    },
  },
};
</script>
